// Generated by GitHub Copilot
import { createFileRoute, useRouter } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { ShieldOff } from 'lucide-react'

export const Route = createFileRoute('/_app/$companyId/not-authorized')({
  component: RouteComponent,
  staticData: {
    title: 'Not Authorized',
  },
})

function RouteComponent() {
  const { t } = useTranslation('general')
  const router = useRouter()

  return (
    <div className="ynt-centered-state-panel">
      <ShieldOff size={56} className="text-secondary" />
      <h2 className="mb-0">{t('notAuthorized.title')}</h2>
      <p className="text-secondary text-center mb-0">{t('notAuthorized.message')}</p>
      <button className="btn btn-outline-secondary" onClick={() => router.history.back()}>
        {t('notAuthorized.back')}
      </button>
    </div>
  )
}
